import React, { useState, useEffect, useContext, useMemo } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import "./UserManagement.scss";
import PopInWindow from "../../components/popInWindow/PopInWindow";
import CreateUser from "../../components/user/CreateUser";
import axios from "axios"; // Optional: Use axios instead of fetch
import { AuthContext } from "../../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import masterApi from "../../services/masterApi";
import UserDetails from "../../components/user/UserDetails";
import { UserRolesEnum, UserRolesEnumLabels } from "../../enum/enums";
import { getRoleName } from "../../utils/common";
import ConfirmationModal from "../../components/confirmationModal/ConfirmationModal";
import Loader from "../../components/loader/Loader";
import defaultImage from "../../assets/images/default-profile.png";

const UserManagement = () => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const DELETE_SUCCESS_MESSAGE = process.env.REACT_APP_DELETE_SUCCESS_MESSAGE;
  const DELETE_ERROR_MESSAGE = process.env.REACT_APP_DELETE_ERROR_MESSAGE;
  const [ShowPopin, setShowPopin] = useState(false);
  const [records, setRecords] = useState([]);
  const [editingRow, setEditingRow] = useState(null);  
  const [searchQuery, setSearchQuery] = useState('');
  const { user } = useContext(AuthContext);
  const [role, setRole] = useState(UserRolesEnum.TECHINICIAN);
  const [roleEnumValues, setUserRolesEnum] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [ isExpertiseRequired,setExpertiseRequired ] = useState(true);
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    try {
      const userRoleValue = user?.userRole;
      const response = await masterApi.getUsersByRole({ userRoleValue });
      const filteredUsers = response?.data?.usersList?.filter(user => user.userRole !== 'superAdmin');
      setRecords(filteredUsers);
      } catch (error) {
    } finally {
    }
  };
  useEffect(() => {
    fetchData();
  }, [ShowPopin]); // Empty dependency array means it runs once on component mount

  useEffect(() => {
    const filteredRoles = Object.keys(UserRolesEnum).filter(
      (role) => UserRolesEnum[role] !== UserRolesEnum.SUPER_ADMIN
    );
    setUserRolesEnum(filteredRoles);
    setLoading(false);
  }, []);

 
  const returnExpertise = (expertises) => {
    return expertises?.map((obj) => obj.expertiseName).join(", "); // Example: Join the array into a comma-separated string
  };

  
  const filteredList = useMemo(() => {
    const lowerCaseQuery = searchQuery.toLowerCase();

    return records?.filter((item) =>
      item.userRole && item.userRole.toLowerCase().includes(role.toLowerCase()) &&
      (
        item.firstName.toLowerCase().includes(lowerCaseQuery) ||
        item.lastName.toLowerCase().includes(lowerCaseQuery) ||
        item.email.toLowerCase().includes(lowerCaseQuery) ||
        item.username.toLowerCase().includes(lowerCaseQuery) ||
        item.mobile.toLowerCase().includes(lowerCaseQuery) ||
        item.recordStatus.toLowerCase().includes(lowerCaseQuery) ||
        returnExpertise(item.expertises).toLowerCase().includes(lowerCaseQuery)
      )
    )
  }, [role, records, searchQuery]); // Depend on selectedFilter and dataList to recalculate on changes

  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value); // Update search query state
  };

  
  const handleOptionChange = (event) => {
    setRole(event.target.value); // Update state with the new selected option
    if(event.target.value==UserRolesEnum.TECHINICIAN){
      setLoading(true); 
      setExpertiseRequired(true);
      setLoading(false); 
    }else{
      setLoading(true); 
      setExpertiseRequired(false);
      setLoading(false);
    }
  };

  
  const renderRoles = (row) => {
    return row?.expertises?.map((obj) => obj.expertiseName).join(", "); // Example: Join the array into a comma-separated string
  };

  
  const handleEditClick = (row) => {
    setEditingRow(row); // Set the row to be edited
    setShowUserDetailsPopin(false);
    openPopin();
  };

  const handleDeleteClick = async (row) => {
    const userId = row?._id;
    setIsModalVisible(true);
    setSelectedUserId(userId);
  };

  
  const handleConfirmDelete = async () => {
    const userId = selectedUserId;
    setLoading(true); 
     
      const response = await masterApi.deleteUser({ userId });
      if (response?.ok) {
        setLoading(false); 
        toast.success(DELETE_SUCCESS_MESSAGE, {autoClose: 1000, // 1 seconds
          });
        setShowPopin(ShowPopin);
      } else {
        setLoading(false); 
        toast.error(response.response?.data?.message, {
          autoClose: 2000, // 1 seconds
        });
        
      }
      setIsModalVisible(false);
      await fetchData();
  };
  const [ShowUserDetailsPopin, setShowUserDetailsPopin] = useState(false);
  const openUserDetailsPopin = () => {
    setShowUserDetailsPopin(!ShowUserDetailsPopin);
  };
  
  const handleViewClick = (row) => {    
    if(ShowUserDetailsPopin){
      setEditingRow(null);
    }else{
      setEditingRow(row);
    }
    setShowUserDetailsPopin(!ShowUserDetailsPopin);
  };

  const openPopin = () => {
    setShowPopin(!ShowPopin);
    if (ShowPopin === true) {
      setEditingRow(null);
    }
  };


  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      cell: (row, rowIndex) => (
        <div className="User-name">
          <div className="user-img">
            <img src={BASE_URL + row.profileImagePath} onError={(e)=> e.target.src=defaultImage}></img>
          </div>
          <div className="user-det toolTip">
            <div className="name">{row.firstName} {row.lastName}</div>
            <span>{row.firstName} {row.lastName}</span>
            <div className="dep">{getRoleName(row.userRole)}</div>
          </div>
        </div>
      ),
      sortable: true,
    },
    ...(isExpertiseRequired
      ? [
          {
            name: "Expertise",
            selector: (row) => row.expertises,
            cell: (row) => <div className="table-cell">{renderRoles(row)}</div>,
          },
        ]
      : []),   
    {
      name: "User Name",
      selector: (row) => <div className="table-cell">{row.username}</div>,
    }, 
    {
      name: "Email",
      selector: (row) => <div className="table-cell">{row.email}</div>,
    },
    {
      name: "Phone Number",
      selector: (row) => <div className="table-cell">{row.mobile}</div>,
    },
    {
      name: "Status",
      selector: (row) => <div className="table-cell">{row.recordStatus}</div>,
    },
    {
      name: "",
      cell: (row, rowIndex) => (
        <div className="action-btn">
          <button className="btn view" onClick={() => handleViewClick(row)}>
            <svg width="29.562" height="21.790" viewBox="0 0 29.562 21.772">
              <g
                id="Icon_feather-eye"
                data-name="Icon feather-eye"
                transform="translate(30.562 27.272) rotate(180)"
              >
                <path
                  id="Path_2538"
                  data-name="Path 2538"
                  d="M1.5,16.386S6.693,6,15.781,6,30.062,16.386,30.062,16.386,24.869,26.772,15.781,26.772,1.5,16.386,1.5,16.386Z"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
                <path
                  id="Path_2539"
                  data-name="Path 2539"
                  d="M21.29,17.395A3.895,3.895,0,1,1,17.395,13.5,3.895,3.895,0,0,1,21.29,17.395Z"
                  transform="translate(-1.614 -1.009)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
              </g>
            </svg>
          </button>
          <button className="btn edit" onClick={() => handleEditClick(row)}>
            <svg width="20.248" height="20.053" viewBox="0 0 20.248 20.053">
              <path
                id="Icon_feather-edit-2"
                data-name="Icon feather-edit-2"
                d="M7.64,4.053A2.718,2.718,0,1,0,3.8,7.9L16.768,20.869l5.285,1.441-1.441-5.285Z"
                transform="translate(-2.305 -2.757)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </svg>
          </button>
          <button className="btn delete" onClick={() => handleDeleteClick(row)}>
            <svg width="19.227" height="21.252" viewBox="0 0 19.227 21.252">
              <g
                id="Icon_feather-trash"
                data-name="Icon feather-trash"
                transform="translate(0.5 0.5)"
              >
                <path
                  id="Path_2534"
                  data-name="Path 2534"
                  d="M0,0H18.227"
                  transform="translate(0 4.05)"
                  fill="none"
                  stroke="#e65151"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
                <path
                  id="Path_2535"
                  data-name="Path 2535"
                  d="M14.176,4.05V18.227a2.025,2.025,0,0,1-2.025,2.025H2.025A2.025,2.025,0,0,1,0,18.227V4.05m3.038,0V2.025A2.025,2.025,0,0,1,5.063,0h4.05a2.025,2.025,0,0,1,2.025,2.025V4.05"
                  transform="translate(2.025)"
                  fill="none"
                  stroke="#e65151"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                />
              </g>
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL",
  };
  const ExpandedComponent = ({ data }) => (
    <pre>{JSON.stringify(data, null, 2)}</pre>
  );

 
  const [isModalVisible, setIsModalVisible] = useState(false);


  const handleDelete = () => {
    setIsModalVisible(false); // Close modal after deletion
  };

  const closeModal = () => {
    setIsModalVisible(false); // Close modal
  };

  return (
    <>
    {loading ? (
        <Loader />
      ) : (
    <div className="user-management">
      <div className="user-head">
        <div className="head-switch">
          {roleEnumValues?.map((item, index) => (
            <div className="check1">
              <input
                className=""
                type="radio"
                name={item}
                id={"page" + UserRolesEnumLabels[UserRolesEnum[item]]}
                value={UserRolesEnum[item]}
                checked={UserRolesEnum[item] === role}
                onChange={handleOptionChange}
              ></input>
              <label
                className="form-check-label1"
                htmlFor={"page" + UserRolesEnumLabels[UserRolesEnum[item]]}
              >
                {UserRolesEnumLabels[UserRolesEnum[item]]}
              </label>
            </div>
          ))}
        </div>
        <div className="head-right">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search "
              onChange={handleSearchChange}
            ></input>
            <button className="btn search-icon">
              <svg width="20.207" height="20.207" viewBox="0 0 20.207 20.207">
                <g
                  id="Icon_feather-search"
                  data-name="Icon feather-search"
                  transform="translate(0.5 0.5)"
                >
                  <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M21.389,12.944A8.444,8.444,0,1,1,12.944,4.5,8.444,8.444,0,0,1,21.389,12.944Z"
                    transform="translate(-4.5 -4.5)"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                  <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M29.567,29.567l-4.592-4.592"
                    transform="translate(-10.567 -10.567)"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                  />
                </g>
              </svg>
            </button>
          </div>
          <button className="primary-btn" onClick={openPopin}>
            Add
          </button>
        </div>
      </div>
      <div className="user-table">
        <DataTable
          columns={columns}
          data={filteredList}
          fixedHeader
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[5, 10, 20]}
          paginationComponentOptions={paginationComponentOptions}
          highlightOnHover
          responsive
        />
      </div>
      {ShowPopin && (
        <PopInWindow title={"User"} closePopin={openPopin}>
          <CreateUser close={openPopin} existingData={editingRow} />
        </PopInWindow>
      )}
      {ShowUserDetailsPopin && (
        <PopInWindow closePopin={handleViewClick}>
          <UserDetails
            userData={editingRow}
            closePopin={handleViewClick}
            onButtonClick={handleEditClick}
          />
        </PopInWindow>
      )}

      {/* <ToastContainer autoClose={1500} /> */}
      <ConfirmationModal
        show={isModalVisible}
        title="Delete User"
        message="Are you sure you want to delete this user?"
        onConfirm={handleConfirmDelete}
        onCancel={closeModal}
        confirmText="Yes, Delete"
        cancelText="No, Cancel"
      />
    </div>
    )}
    </>
  );
};

export default UserManagement;
